import '@fontsource/roboto';
import * as React from 'react';

export default function Home() {
    console.log(process.env.REACT_APP_CURRENT_URL_TO_API)
    return <div>
        <h1 id="holamundo">Hola mundo</h1>
    </div>;

}